module.exports = __webpack_public_path__ + "img/auto.004a5c2c.gif";